import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  inject,
} from '@angular/core';

import { ResetPasswordFormComponent } from '../../components/reset-password-form/reset-password-form.component';
import { HttpErrorService } from '@web/common';
import { FormTitleWithSubtitleComponent } from '../../ui/form-title-with-subtitle/form-title-with-subtitle.component';
import { ResetPasswordForm } from '../../models/reset-password-form';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { once } from '@web/utils';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-reset-password',
  imports: [
    FormTitleWithSubtitleComponent,
    ResetPasswordFormComponent,
    AlertsComponent,
  ],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class ResetPasswordComponent {
  private readonly auth = inject(AuthService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly token = input.required<string>();

  protected readonly isFormVisible = signal<boolean>(true);

  public handleSubmitClickEvent(form: ResetPasswordForm): void {
    this.auth
      .resetPassword(this.token(), form)
      .pipe(once())
      .subscribe({
        next: () => {
          this.showSuccessAlert();
          this.markFormAsInvisible();
        },
        error: (response) => {
          this.showFailureAlertByResponse(response);
        },
      });
  }

  private showSuccessAlert(): void {
    this.alerts.showSingle((builder) =>
      builder
        .initSuccess(
          'Twoje hasło zostało pomyślnie zresetowane. Możesz teraz zalogować się, używając nowego hasła.',
        )
        .closeable(false)
        .build(),
    );
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }

  private markFormAsInvisible(): void {
    this.isFormVisible.set(false);
  }
}
